import { Component, Input, OnInit, SimpleChange } from "@angular/core";
import { statusToColor } from "../hd-status/hd-status.service";

@Component({
  selector: "hd-detail-tip",
  templateUrl: "./hd-detail-tip.component.html",
  styleUrls: ["./hd-detail-tip.component.less"],
})
export class HdDetailTipComponent implements OnInit {
  constructor() {}
  @Input() state: string;
  @Input() stateText: string;
  @Input() billNumber: string;
  @Input() tip: string = "详情";
  statusColor: string;

  ngOnInit() {
    this.setStatusColor();
  }

  ngOnChanges() {
    this.setStatusColor();
  }

  setStatusColor() {
    let findKey = '';
    for (let key in statusToColor) {
      if (
        this.state &&
        (statusToColor[key].indexOf(this.state) !== -1 ||
        statusToColor[key].indexOf(this.state.toUpperCase()) !== -1 ||
        statusToColor[key].indexOf(this.state.toLowerCase()) !== -1)
      ) {
        findKey = key;
      }
    }
    if (findKey) {
      this.statusColor = findKey;
    } else {
      this.statusColor = '#9FA4A2';
    }
  }
}
